module.exports = __webpack_public_path__ + "img/dashboard-fill.3f72e7dc.svg";